/** @jsx jsx */

import React, { Fragment as _, memo } from 'react';
import { connect } from 'react-redux';

const Media = connect((state: any, props: any) => ({
  child: state.blocks[props.id].props.child,
  children: props.children,
}))(({ children, child }) => children[child]);

export default Media;
